
<div>
  <UserNavbar></UserNavbar>
  <router-view />
</div>
